function getClientContext() {
  return JSON.stringify({
    client: {
      user_tracking_id: 'b9668e40-7ed5-11e8-95c4-e39c9a11d2a0',
      app_title: 'Bus Account Open',
      app_package_name: 'WEB',
      app_version_code: '5.0',
      app_version_name: '0.8'
    },
    env: {
      platform_version: window.navigator.appVersion,
      make: 'MacIntel',
      locale: 'en-US',
      platform: window.navigator.platform
    }
  });
}

export default getClientContext;
